type ArrowLeftProps = {
  className?: string;
  fill?: string;
};

const ArrowLeft = ({ className, fill }: ArrowLeftProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/Arrow/Back/24dp">
      <path
        id="Vector"
        d="M7.82505 12.9998L12.725 17.8998C12.925 18.0998 13.0209 18.3331 13.0125 18.5998C13.0042 18.8665 12.9 19.0998 12.7 19.2998C12.5 19.4831 12.2667 19.579 12 19.5873C11.7334 19.5956 11.5 19.4998 11.3 19.2998L4.70005 12.6998C4.60005 12.5998 4.52922 12.4915 4.48755 12.3748C4.44588 12.2581 4.42505 12.1331 4.42505 11.9998C4.42505 11.8665 4.44588 11.7415 4.48755 11.6248C4.52922 11.5081 4.60005 11.3998 4.70005 11.2998L11.3 4.6998C11.4834 4.51647 11.7125 4.4248 11.9875 4.4248C12.2625 4.4248 12.5 4.51647 12.7 4.6998C12.9 4.8998 13 5.1373 13 5.4123C13 5.6873 12.9 5.9248 12.7 6.1248L7.82505 10.9998H19C19.2834 10.9998 19.5209 11.0956 19.7125 11.2873C19.9042 11.479 20 11.7165 20 11.9998C20 12.2831 19.9042 12.5206 19.7125 12.7123C19.5209 12.904 19.2834 12.9998 19 12.9998H7.82505Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default ArrowLeft;
